<template>
    <div class="header">
       <img :style="{'filter':filter}" src="https://www.lefisc.com.br/reclef/img/Revisor da Exclusão do ICMS do PISCOFINS_Prancheta 1.png" alt="reclef" >
    </div>
</template>

<script>

export default {
props:['filter']
}
</script>

<style>
.header{
    height: 4vw;
    min-height: 65px;
    width: 100%;
    max-width: 1300px;
    background-image: url('https://www.lefisc.com.br/reclef/img/fundo%20menor-02.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-color: #e70e11;
    background-blend-mode: multiply;   
    display: flex;    
    justify-content: center;  
    align-items: center;
}
.header img{
    width: 210px;
}
</style>